import { AccountShareholderModal } from 'components/accounts/AccountShareholderModal'
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  LabelValueList,
  PencilAltIcon,
  useModal,
  useRouter,
} from '@forgeglobal/design-framework'
import { useShareholderDetailsDataQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

const ShareHolderSection: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const accountId = match.params.id
  const { data } = useShareholderDetailsDataQuery({ variables: { id: accountId } })
  const account = data?.account
  const notes = account?.shareholder_notes ?? ''
  const participatesSecondaries = account?.participates_in_secondaries ?? false
  const secondariesRow = participatesSecondaries
    ? [{ label: '[Placeholder]', value: 'Participates in secondaries' }]
    : []
  const [showModal, hideModal] = useModal(() => {
    return <AccountShareholderModal hideModal={hideModal} accountId={accountId} />
  }, [accountId])
  return (
    <Card>
      <CardHeader
        title="Shareholder Details"
        action={
          <IconButton onClick={showModal}>
            <PencilAltIcon />
          </IconButton>
        }
      />
      <CardContent>
        <LabelValueList
          items={[...secondariesRow, { label: 'Additional information', value: notes, fullWidth: true }]}
        />
      </CardContent>
    </Card>
  )
}

export { ShareHolderSection }
